import React from 'react';
import Link from 'next/link';
import Container from './container';
import { ISponsor } from '../models/sponsor';
import { Label } from './text';
import classNames from 'classnames';

interface IProps {
	sponsors: ISponsor[];
}

export default function Footer({ sponsors }: IProps) {
	const trimText = (text: string) => {
		const words = text.split(' ');
		return words[0].toLowerCase();
	};

	const isMediaPartner = (subtitle: string) => {
		return subtitle === 'MEDIA PARTNER';
	};

	// change the order of mainsponsors, first naamgevend partner, then maatschappelijk partner, then media partner
	const order = ['naamgevend partner', 'maatschappelijk partner', 'media partner'];

	// A subtitle that isn't in `order` sorts last; without this it scores -1 and
	// jumps ahead of the naamgevend partner.
	const orderIndex = (subtitle: string) => {
		const index = order.indexOf(subtitle.toLowerCase());
		return index === -1 ? order.length : index;
	};

	const mainSponsors = sponsors
		?.filter((sponsor) => sponsor.sponsor_fields.mainSponsor)
		.sort((a, b) => orderIndex(a.sponsor_fields.subtitle) - orderIndex(b.sponsor_fields.subtitle));

	const remainingSponsors = sponsors?.filter((sponsor) => !sponsor.sponsor_fields.mainSponsor);

	// Remove sponsors from remainingSponsors when the title is "OFS Groep", "Opta", "Southfiels", ""Sparenti"
	const filteredSponsors = remainingSponsors?.filter((sponsor) => {
		const title = sponsor.title;
		return title !== 'OFS Groep' && title !== 'Opta' && title !== 'Southfields' && title !== 'Sparenti';
	});

	return (
		<footer className="footer-sponsors bg-kkd-semi-dark lg:px-32 py-12 divide-y divide-gray-500 ">
			<section className="py-6 lg:py-12">
				<Container>
					<div className="flex flex-wrap justify-center">
						{mainSponsors?.map((sponsor, i) => (
							<div
								key={i}
								className={classNames(
									trimText(sponsor.sponsor_fields.subtitle),
									`mb-6 lg:mb-8 w-full sm:w-1/3 lg:w-1/4 p-2`,
								)}
							>
								<Link href={sponsor.sponsor_fields.websiteUrl} target="_blank">
									<div className="flex flex-col items-center">
										<img
											src={sponsor.sponsor_fields.invertedImage?.sourceUrl}
											alt={sponsor.sponsor_fields.subtitle}
											className={classNames(
												'p-4 mb-2 object-contain w-full transition-opacity hover:opacity-70 invert-0 grayscale',
												isMediaPartner(sponsor.sponsor_fields.subtitle)
													? 'h-24 md:h-32 contrast-[0.2]' // Custom styling for Media Partner
													: 'h-24 md:h-32 contrast-[0.5]',
											)}
										/>
										<Label className="uppercase font-inter tracking-wider text-xs text-gray-500 hover:text-gray-800">
											{sponsor.sponsor_fields.subtitle}
										</Label>
									</div>
								</Link>
							</div>
						))}
					</div>
				</Container>
			</section>

			<section className="py-12">
				<Container>
					<div className="flex flex-wrap justify-center">
						{filteredSponsors?.map((sponsor, i) => (
							<div key={i} className="mb-6 lg:mb-8 w-full sm:w-1/3 p-2 hover:cursor-pointer">
								<Link href={sponsor.sponsor_fields.websiteUrl} target="_blank">
									<div className="flex flex-col items-center">
										<img
											src={sponsor.sponsor_fields.invertedImage?.sourceUrl}
											alt={sponsor.sponsor_fields.subtitle}
											className="mb-4 h-8 lg:h-16 lg:object-cover transition-opacity hover:opacity-70 invert-0 grayscale contrast-[0.1]"
										/>
										<Label className="uppercase font-inter tracking-wider text-xs text-gray-500 hover:text-gray-800">
											{sponsor.sponsor_fields.subtitle}
										</Label>
									</div>
								</Link>
							</div>
						))}
					</div>
				</Container>
			</section>
		</footer>
	);
}
